const ExcelColumnNames = {
  axis: ['CLIENT_ID', 'APPLICATION_NO', 'CUSTOMER_NAME', 'PAN', 'MOBILE', 'ACC DT', 'ACC STAT'],
  bajaj: ['CLIENTNAME', 'CLIENTMOBILE', 'CLIENTEMAIL', 'LEADCREATEDDATE', 'CLIENTSTATUS'],
  hdfc: ['CONTACT NUMBER', 'ACC STATUS', 'DATE_OF_ACTIVATION'],
  icici: ['PAN', 'NAME', 'MOBILE_NUMBER', 'APPLICATION DATE', 'STAGE', 'FORM_NO', 'ACC_OPEN_DATE', 'NCA DATE', 'STATUS'],
  iifl: ['CLIENTCODE', 'MOBILE', 'ACC STAT', 'ACCOUNTS ACTIVATED'],
  kotak: ['FIRST NAME', 'CLIENT ID', 'CREATED ON', 'LEAD NUMBER', 'PAN NUMBER', 'LEAD STAGE MAPPING', 'TRADE CODE GEN DATE'],
  marwadi: ['REFFERALCODE','PANNO', 'MOBILENO', 'PNAME', 'ACC STAT', 'ACC DT', 'PCODE', 'DPID', 'CLIENTID', 'CRTIME'],
  religare: ['PAN', 'MOBILE_NUMBER', 'NAME_OF_THE_INVESTOR', 'APPLICATION_ID', 'CLIENT_DP_ID', 'DP_ID', 'APPLICATION_DATE_TIME', 'APPLICATION_STATUS', 'ACCOUNT_ACTIVATION_DATE_TIME', 'REFERENCE_ID'],
  ventura: ['PAN', 'MOBILE NUMBER', 'NAME OF THE INVESTOR', 'STATUS', 'ACC DT', 'APPLICATION ID', 'CLIENT ID', 'APP DT'],
  zerodha: ['LEAD_ID', 'FULL_NAME', 'CLIENT_ID', 'EQUITY_OPENED_TIME', 'MAIL', 'MOBILE', 'STATUS']
}

const APIColumnNames = {
  axis: ['CLIENT_ID', 'APPLICATION_NO', 'CUSTOMER_NAME', 'PAN', 'MOBILE', 'ACC_DT', 'ACC_STAT'],
  bajaj: ['CLIENT_NAME', 'CLIENT_MOBILE', 'CLIENT_EMAIL', 'LEAD_CREATED_DATE', 'CLIENT_STATUS'],
  hdfc: ['CONTACT_NUMBER', 'ACC_STATUS', 'DATE_OF_ACTIVATION'],
  icici: ['PAN', 'NAME', 'MOBILE_NUMBER', 'APPLICATION_DATE', 'STAGE', 'FORM_NO', 'ACC_OPEN_DATE', 'NCA_DATE', 'STATUS'],
  iifl: ['CLIENT_CODE', 'MOBILE', 'ACC_STAT', 'ACCOUNT_ACTIVATED'],
  kotak: ['NAME', 'CLIENT_ID', 'CREATED_ON', 'LEAD_NUMBER', 'PAN', 'LEAD_STAGE', 'TRADE_CODE_GENDT'],
  marwadi: ['REFERRAL_CODE', 'PAN', 'MOBILE', 'NAME', 'ACC_STAT', 'ACC_DT', 'PCODE', 'DPID', 'CLIENT_ID', 'CR_TIME'],
  religare: ['PAN', 'MOBILE', 'NAME', 'APPLICATION_ID', 'CLIENT_ID', 'DP_ID', 'APPLICATION_DATE', 'APPLICATION_STATUS', 'ACCOUNT_ACTIVATION_TIME', 'REFERENCE_ID'],
  ventura: ['PAN', 'MOBILE', 'NAME', 'STATUS', 'ACC_DT', 'APPLICATION_ID', 'CLIENT_ID', 'APP_DT'],
  zerodha: ['LEAD_ID', 'NAME', 'CLIENT_ID', 'EQUITY_OPEN_TIME', 'MAIL', 'MOBILE', 'STATUS'],
}

export { ExcelColumnNames, APIColumnNames };
